import { useParams, Link } from "react-router-dom";
import { App as WorkoutApp } from "../workout/App";

/**
 * Equivalent of the C# `Sessions/Active` view. There, the session id came from
 * a `data-session-id` attribute rendered into the page and the app was mounted
 * by its own `main.tsx`; here it comes from the route and React Router mounts
 * it, but the component underneath is the same one.
 */
export default function SessionActivePage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="mx-auto max-w-lg p-6 text-center">
        <p className="text-body text-gray-600 dark:text-gray-300">
          That workout link is missing a session.
        </p>
        <Link
          to="/sessions"
          className="mt-4 inline-block rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          data-testid="workout-back-to-sessions"
        >
          Back to sessions
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="workout-app-container">
      <WorkoutApp sessionId={id} />
    </div>
  );
}
